module.exports = __webpack_public_path__ + "img/horizontal_7_3_pp3_7005.8764f8ab.png";